/**
 * Returns the end-of-document host for UI that must appear above the map.
 * The fallback keeps standalone entry points working.
 */
export function getAppOverlayHost(): HTMLElement {
  return document.getElementById('app-overlays') ?? document.body;
}

/**
 * Returns the host for floating panels that must paint above the command bar.
 * Its position after the command bar defines the order without another stacking level.
 */
export function getAppFloatingPanelHost(): HTMLElement {
  return document.getElementById('app-floating-panels') ?? getAppOverlayHost();
}
